import script from "./alert.vue?vue&type=script&setup=true&lang=ts"
export * from "./alert.vue?vue&type=script&setup=true&lang=ts"

import "./alert.vue?vue&type=style&index=0&id=5d18f72a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d18f72a"]])

export default __exports__